import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=2443db30&"
import script from "./CreateAccount.vue?vue&type=script&lang=js&"
export * from "./CreateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2443db30')) {
      api.createRecord('2443db30', component.options)
    } else {
      api.reload('2443db30', component.options)
    }
    module.hot.accept("./CreateAccount.vue?vue&type=template&id=2443db30&", function () {
      api.rerender('2443db30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/register/steps/CreateAccount.vue"
export default component.exports